/* eslint-disable @typescript-eslint/naming-convention */
import { AddSuperProps, TooltipContext } from "@super-ui/interfaces";
import { PlanDetailsItem, RenderingDetails } from "@swiggy-private/cart-types";

export interface ImageBuilderArguments {
    cloudinaryId?: string;
    width: string;
    height: string;
    imageVerticalAlign: string;
}

interface IAttributeValues {
    behaviour: string;
}

export interface BenefitsListItem {
    title: string;
    sub_title: string;
    show_shimmer: boolean;
    attribute_values?: IAttributeValues;
    goToMenu?: VoidFunction;
}

export enum CTATypes {
    OPEN_SUPER_V3_DEEPLINK = "DEEPLINK",
    ONE_TAP_ADD = "ADD_PLAN",
    ONE_TAP_REMOVE = "REMOVE_PLAN",
    BENEFITS_LIST_DEEPLINK = "BENEFITS_LIST_DEEPLINK",
    CHANGE_PLAN = "CHANGE_PLAN",
}

export interface CTA {
    color: string | null;
    link: string;
    type: CTATypes;
    text: string;
    visible_message: string;
}

export interface DLSWrapperAsSDKProps {
    boxShadowOnDLSWidget?: string;
    planRemovalBottomsheetPortalRootId?: string;
    disableDefaultDLSWrapperContainer?: boolean;
}

export interface SwiggyOneWidgetClickHandler {
    addSuper: (addSuperProps: AddSuperProps) => void;
    removeSuper: VoidFunction;
    changeSuper: (plan: PlanDetailsItem, ctaLink: string, isOneTap: boolean) => void;
    navigateToDeeplinkGenericHelper: (link: string) => void;
    onClickRemoveSuperEvent: (planId: string, planName: string, planPrice: string) => void;
    onItemClick?: (itemType: string, itemData?: RenderingDetails) => void;
    setShowRemovePlanConfirmation: (show: boolean) => void;
    onClickSuperViewAllBenefitsCTA: (ctaText: string, ctaLink: string, toolTipText?: TooltipContext) => void;
    extraOfferClickHandler: () => void;
}

export type SwiggyOneWidgetExtraConfig = DLSWrapperAsSDKProps;

export interface SwiggyOneBottomsheetHandlers {
    removeSuper: VoidFunction;
    setShowRemovePlanConfirmation: (show: boolean) => void;
    impressionSuperRemovePlanConfirmationHalfCard: ({
        savingsValue,
        title,
        message,
        subMessage,
        planId,
        variant,
        initialBillAmount,
        finalBillAmount,
    }: {
        savingsValue: string;
        title: string;
        message: string;
        subMessage: string;
        planId?: string;
        variant?: string;
        initialBillAmount?: string;
        finalBillAmount?: string;
    }) => void;
    impressionSuperRemovePlanHalfCardRemoveButton: ({
        planName,
        planId,
        cta,
        variant,
        initialBillAmount,
        finalBillAmount,
    }: {
        planName: string;
        planId: string;
        cta: string;
        variant?: string;
        initialBillAmount?: string;
        finalBillAmount?: string;
    }) => void;
    impressionSuperRemovePlanHalfCardBackButton: ({
        planName,
        planId,
        cta,
        variant,
        initialBillAmount,
        finalBillAmount,
    }: {
        planName: string;
        planId: string;
        cta: string;
        variant?: string;
        initialBillAmount?: string;
        finalBillAmount?: string;
    }) => void;
    onClickSuperRemovePlanHalfCardBackButton: ({
        planName,
        planId,
        cta,
        variant,
        initialBillAmount,
        finalBillAmount,
    }: {
        planName: string;
        planId: string;
        cta: string;
        variant?: string;
        initialBillAmount?: string;
        finalBillAmount?: string;
    }) => void;
    onClickSuperRemovePlanHalfCardRemoveButton: ({
        planName,
        planId,
        cta,
        variant,
        initialBillAmount,
        finalBillAmount,
    }: {
        planName: string;
        planId: string;
        cta: string;
        variant?: string;
        initialBillAmount?: string;
        finalBillAmount?: string;
    }) => void;
}

export interface SwiggyOneWidgetTypeConfig {
    isOneTapAdd: boolean;
    isOneTapRemove: boolean;
    toolTipContext?: TooltipContext;
}

export enum MovNotMet {
    MOV_NOT_MET = "MOV_NOT_MET",
}
